import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CodigoState {
  codigoRegional: string;
  codigoCooperativa: string;
  codigoTipoVeiculo: string;
  valorFipe: string;
}

const initialState: CodigoState = {
  codigoRegional: '',
  codigoCooperativa: '',
  codigoTipoVeiculo: '',
  valorFipe: '',
};

const codigoSlice = createSlice({
  name: 'codigo',
  initialState,
  reducers: {
    setCodigoData(state, action: PayloadAction<CodigoState>) {
      state.codigoRegional = action.payload.codigoRegional;
      state.codigoCooperativa = action.payload.codigoCooperativa;
      state.codigoTipoVeiculo = action.payload.codigoTipoVeiculo;
      state.valorFipe = action.payload.valorFipe;
    },
    resetCodigoData(state) {
      state.codigoRegional = '';
      state.codigoCooperativa = '';
      state.codigoTipoVeiculo = '';
      state.valorFipe = '';
    },
  },
});

export const { setCodigoData, resetCodigoData } = codigoSlice.actions;

export default codigoSlice.reducer;
